import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ShimmerDirective } from '../../../directives/shimmer.directive';

@Component({
  selector: 'lib-date-badge',
  imports: [DatePipe, ShimmerDirective],
  templateUrl: './date-badge.component.html',
  styleUrl: './date-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateBadgeComponent {
  readonly startDate = input.required<Date>();
  readonly endDate = input<Date | null>(null);
  readonly isLoading = input<boolean>(false);
  protected readonly hasMonthSpan = computed(() => {
    const endDate = this.endDate();

    return !!endDate && endDate.getMonth() !== this.startDate().getMonth();
  });

  protected readonly hasYearSpan = computed(() => {
    const endDate = this.endDate();
    return !!endDate && endDate.getFullYear() !== this.startDate().getFullYear();
  });

  protected readonly hasDaySpan = computed(() => {
    const endDate = this.endDate();
    return !!endDate && endDate.toDateString() !== this.startDate().toDateString();
  });
}
